export interface IContactPoint {
    use: string;
    system: string;
    value: string;
    rank: string;
    period: string;
    tenantId: number;
    language: string;
}